(function ($) {

	//.ptx-coursenav button
	$( ".ptx-tableofcontents a" ).on( "click", function() {
		$( ".ptx-site").attr("data-overlay",'none');
	});
  
  })(jQuery);